import validate from 'lib/utils/validationRules';
import { formatAmount, normalizeAmount } from 'lib/utils/amount';

import Attachment from 'lib/project/classes/Attachment';
import Widget from 'services/widget/Widget';

class GoalWidget extends Widget {
  // eslint-disable-next-line complexity
  constructor(data) {
    super();

    this.amountGoal = formatAmount(data.amountGoal, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
    this.attachment = new Attachment(data.attachment);
    this.code = data?.code || null;
    this.currency = data.currency;
    this.currentProgress = data?.currentProgress || 0;
    this.currentProgressPercent = data?.currentProgressPercent || 0;
    this.description = data?.description || null;
    this.startFrom = this.getStartFrom(data);
    this.type = 'DONATION_GOAL';
    this.status = data.status || Widget.ACTIVE;
  }

  getStartFrom(data) {
    const { currentProgress, startFrom } = data;

    if (validate.isNull(currentProgress)) {
      return formatAmount(startFrom, {
        significant_zeros: data.currency.significant_zeros,
        type: data.currency.type,
      });
    }

    return formatAmount(currentProgress, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
  }

  normalizeAmountGoal() {
    return normalizeAmount(this.amountGoal, this.currency);
  }

  normalizeStartFrom() {
    return normalizeAmount(this.startFrom, this.currency);
  }

  normalizeDescription() {
    return validate.isNotEmptyString(this.description) ? this.description : null;
  }

  getData() {
    return {
      amountGoal: this.normalizeAmountGoal(),
      attachment: this.attachment.getData(),
      code: this.code,
      description: this.normalizeDescription(),
      startFrom: this.normalizeStartFrom(),
      status: this.status,
      type: this.type,
    };
  }
}

export default GoalWidget;
